// @flow
const BASE_URL = 'https://api-staging-internal.mozio.com'
const BASE_URL_V2 = 'https://api-staging-internal.mozio.com/v2'
const AUTH_TOKEN_ID = 'mozio-auth-token'
const REFRESH_TOKEN_ID = 'mozio-refresh-token'
const DEFAULT_REQUEST_PARAMS = {
  api_key: 'c09cc3d01bbe22cb5d7afab4f82c8f3f',
}
const LANGUAGE = 'en_US'
const PARTNER_REF = ''
const CREDENTIALS_STORAGE_TYPE = 'LocalStorage'

export const defaultOptions = {
  BASE_URL,
  BASE_URL_V2,
  AUTH_TOKEN_ID,
  REFRESH_TOKEN_ID,
  DEFAULT_REQUEST_PARAMS,
  LANGUAGE,
  PARTNER_REF,
  CREDENTIALS_STORAGE_TYPE,
  ON_REFRESH_EXPIRED_JWT: null,
  NO_COMPACT_PRICE: false,
  AMENITIES_FILTER: () => true,
  BASE_URL_SEARCH: null,
  BASE_URL_PRICING: null,
  BASE_URL_RESERVATIONS: null,
  BASE_URL_PAYMENTS: null,
  DISTINCT_ID: null,
}

const config = defaultOptions

/**
 * Set SDK configuration.
 * @param {Object} [options] Configuration options
 * @param {string} [options.BASE_URL] HTTP API base endpoint
 * @param {string} [options.AUTH_TOKEN_ID] Auth token ID
 * @param {Object} [options.DEFAULT_REQUEST_PARAMS] Default params for all requests
 * @param {string} [options.LANGUAGE] API responses language.
 * @param {string} [options.CREDENTIALS_STORAGE_TYPE] Type of storage: "Memory" or "LocalStorage"
 * @param {Function} [options.ON_REFRESH_EXPIRED_JWT] Callback to handle even when token updated
 * @return {Object} Configuration
 */
function setConfig(options: ?Object): Object {
  return Object.assign(config, options)
}

export default setConfig
export { config }
